import { render } from "./DickSlider.vue?vue&type=template&id=9f82fc3c"
import script from "./DickSlider.vue?vue&type=script&lang=js"
export * from "./DickSlider.vue?vue&type=script&lang=js"

import "./DickSlider.vue?vue&type=style&index=0&id=9f82fc3c&lang=css"
script.render = render

export default script